import { createI18n } from 'vue-i18n'

let i18n = null
if (window.embeddedTranslations) {
  i18n = createI18n({
    locale: window.embeddedTranslations.locale,
    fallbackLocale: 'en',
    allowComposition: true, // this is needed in Vue 3!
    globalInjection: true,
    messages: window.embeddedTranslations.translations,
  })
} else {
  i18n = createI18n({
    locale: 'en',
    allowComposition: true, // this is needed in Vue 3!
    globalInjection: true,
    messages: {},
  })
}

export default i18n
